import { Box } from '@rbilabs/universal-components';
import { spacing } from '@rbilabs/universal-components/themes';
import { StyleSheet } from 'react-native';

import { MENU_TILE_GRID_HALF_GAP } from 'pages/menu/components/menu-tile-grid/styled';
import { theme } from 'styles/configure-theme';
import { baseTextStyle, primitive, serifFontFamily } from 'styles/constants/primitives';

export const MenuSectionGridItemWrapper = Box.withConfig({
  margin: `${MENU_TILE_GRID_HALF_GAP}px`,
  _web: {
    maxWidth: `calc(33% - ${MENU_TILE_GRID_HALF_GAP}px)`,
  },
  borderRadius: 12,
  minHeight: '220px',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
});

const MENU_IMAGE_MOBILE_WIDTH = 104;
const MENU_IMAGE_DESKTOP_WIDTH = 248;

export const menuSectionStyles = StyleSheet.create({
  menuSectionRow: {
    flexShrink: 1,
    flexGrow: 1,
    backgroundColor: primitive.$white,
    height: 112,
    alignItems: 'center',
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$2,
    flexDirection: 'row',
  },
  menuSectionImageWrapper: {
    minWidth: MENU_IMAGE_MOBILE_WIDTH,
  },
  menuSectionImage: {
    width: MENU_IMAGE_MOBILE_WIDTH,
    height: MENU_IMAGE_MOBILE_WIDTH,
    borderRadius: 10,
  },
  menuSectionImageDesktop: {
    width: MENU_IMAGE_DESKTOP_WIDTH,
    height: MENU_IMAGE_DESKTOP_WIDTH,
    borderRadius: 10,
  },
  menuSectionContent: {
    flexShrink: 1,
    paddingHorizontal: spacing.$3,
  },
  menuSectionTitle: {
    ...baseTextStyle,
    fontSize: 18,
    color: primitive.bk.$bbqBrown,
    fontFamily: serifFontFamily,
  },
  menuSectionProductWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: spacing.$1,
  },
  menuSectionItemPrice: {
    ...baseTextStyle,
    marginRight: spacing.$3,
    fontWeight: 'bold',
    fontFamily: serifFontFamily,
  },
  menuSectionItemCalories: {
    ...baseTextStyle,
    textTransform: 'capitalize',
    fontWeight: 'bold',
  },
});

export const MenuSectionGridFooter = Box.withConfig<{ isMenuItem: boolean }>(p => ({
  justifyContent: 'center',
  alignItems: 'center',
  height: p.isMenuItem ? '92px' : '54px',
  borderBottomRadius: Styles.borderRadius,
  _text: {
    variant: 'headerTwo',
    color: theme.token('text-default'),
    margin: '0',
    fontSize: 'lg',
    lineHeight: '20px',
    textAlign: 'center',
  },
}));
